import styled from 'styled-components'

interface RowSpacerProps {
	size?: number
}

const RowSpacer = styled.div<RowSpacerProps>`
	height: ${props => props.size}px;
`

RowSpacer.defaultProps = {
	size: 20,
}

export default RowSpacer
